import { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import CartService from "../../services/CartService";
import { AuthContext } from "../../Auth/AuthProvider";

export default function CheckOut() {
  const [products, setProducts] = useState({ items: [] });
  const [mobile, setMobile] = useState("");
  const [address, setAddress] = useState("");
  const deliveryCharge = 100;
  const totalPrice = products.items.reduce((sum, product) => sum + (product.price * product.quantity), 0);
  const grandTotal = totalPrice + deliveryCharge;
  const auth = useContext(AuthContext)
  const navigate = useNavigate();
  useEffect(() => {
    auth.getData();
    CartService.getCartItems()
      .then((res) => {
        setProducts(res.data);
      })
      .catch((err) => {
        alert(err);
      });
  }, []);
  useEffect(() => {
    const script = document.createElement("script");
    script.src = "https://checkout.razorpay.com/v1/checkout.js";
    script.async = true;
    document.body.appendChild(script);
    return () => {
      document.body.removeChild(script);
    };
  }, []);
  const handlePayment = async () => {
    if (!mobile || !address) {
      alert("Please enter mobile number and delivery address");
      return;
    }
    try {
      const response = await CartService.createOrder(grandTotal*100);
      const { order } = await response.data;
      const options = {
        key: process.env.REACT_APP_RAZORPAY_KEY_ID,
        amount: order.amount,
        currency: "INR",
        name: "Gerado",
        description: "Order Payment",
        order_id: order.id,
        handler: async function (response) {
          try {
            const verifyResponse = await CartService.verifyPayment({order_id: response.razorpay_order_id,
                payment_id: response.razorpay_payment_id,
                signature: response.razorpay_signature,
                mobile:mobile,
                address:address,
                totalAmount:grandTotal,
                userData:auth.userData,
              });
            const verification = await verifyResponse.data;            
            if (verification.success) {
              await CartService.clearCart();
              navigate("/success");
            } 
            else {
              navigate("/failure");
            }
          } 
          catch (err) {
            console.error("Payment verification error:", err);
            navigate("/failure");
          }
        },
        prefill: {
          name: `${auth.userData.firstName} ${auth.userData.lastName}`,
          email: auth.userData.email,
          contact: mobile,
        },
        theme: {
          color: "#f0be51",
        },
        modal: {
          ondismiss: function() {
            navigate("/failure");
          }
        }
      };
      const rzp = new window.Razorpay(options);
      rzp.open();
    } catch (err) {
      alert("Error creating order: " + err.message);
    }
  };
  const handleCashOnDelivery = async() => {
    try {
      if(!mobile || !address) {
        alert("Please enter mobile number and delivery address");
        return;
      }
      await CartService.placeCashOnDelivery({mobile:mobile,address:address});
      await CartService.clearCart();
      navigate("/success");
    }
    catch(err) {
      alert("Place COD failed");
    }
  }
  return (
    <div className="max-w-md mx-auto p-5 rounded-lg shadow transition-colors duration-300 bg-white text-gray-900 border border-gray-200 dark:bg-gray-900 dark:text-white dark:border-gray-700">
      <h2 className="text-xl font-bold mb-2">Checkout</h2>
      <h3 className="font-semibold mb-2">Products</h3>
      <ul>
        {products.items &&
          products.items.map((product, idx) => (
            <li key={idx} className="flex justify-between py-1">
              <span className="flex flex-cols gap-5">
                <img src={product.image} width={100} loading="lazy" alt="Product" />
                <span>(Qty: {product.quantity})</span>
              </span>
              <span>₹ {(product.price * product.quantity).toFixed(2)}</span>
            </li>
          ))}
      </ul>
      <div className="flex justify-between mt-2 font-semibold">
        <span>Total:</span>
        <span>₹ {totalPrice.toFixed(2)}</span>
      </div>
      <div className="mt-4">
        <label className="block font-semibold mb-1">
          Mobile Number:
          <input
            type="number"
            placeholder="Enter your mobile number"
            value={mobile}
            onChange={(e) => setMobile(e.target.value)}
            className="w-full mt-1 p-2 rounded border outline-none bg-gray-50 text-gray-900 border-gray-300 dark:bg-gray-800 dark:text-white dark:border-gray-600"
          />
        </label>
      </div>
      <div className="mt-4">
        <label className="block font-semibold mb-1">
          Delivery Address:
          <textarea
            type="text"
            placeholder="Enter your address"
            value={address}
            onChange={(e) => setAddress(e.target.value)}
            className="w-full mt-1 p-2 rounded border outline-none bg-gray-50 text-gray-900 border-gray-300 dark:bg-gray-800 dark:text-white dark:border-gray-600"
          />
        </label>
      </div>
      <div className="flex justify-between mt-3">
        <span>Delivery Charge:</span>
        <span>₹ {deliveryCharge.toFixed(2)}</span>
      </div>
      <div className="flex justify-between mt-3 font-bold">
        <span>Grand Total:</span>
        <span>₹ {grandTotal.toFixed(2)}</span>
      </div>
      <button onClick={handlePayment} className="w-full mt-5 py-2 rounded font-semibold transition-colors bg-amber-600 text-white hover:bg-amber-700 dark:bg-amber-700 dark:text-white dark:hover:bg-amber-600">
        Pay Online
      </button>
      <button onClick={handleCashOnDelivery} className="w-full mt-5 py-2 rounded font-semibold transition-colors bg-amber-600 text-white hover:bg-amber-700 dark:bg-amber-700 dark:text-white dark:hover:bg-amber-600">
        Cash On Delivery
      </button>
    </div>
  );
}
